import React from 'react'

export type PopoverComponentProps = {
    onTogglePopover?    : {(value: boolean): void}
}

type PopoverComponentState = {
    showPopover : boolean
}

export default class PopoverComponent<T extends PopoverComponentProps> extends React.Component<T, PopoverComponentState> {

    constructor(props: T) {
        super(props)

        this.state = _.assign(this.state, {
            showPopover: false
        });

        this._bind('showPopover', 'hidePopover', 'togglePopover')
    }

    _bind(...methods:any) {
        methods.forEach((method:any)=>{
            try {
                // @ts-ignore
                this[method] = this[method].bind(this);
            } catch(err) {
                console.error("BaseComponent","_bind error:", method, err);
            }
        });
    }

    showPopover(e?: React.MouseEvent, callback?: func) {
        if (e) e.stopPropagation()

        this.setState({
            showPopover: true
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(true)
            if (callback) callback()
        })
    }

    hidePopover(e?: React.MouseEvent, callback?: func) {
        if (e) e.stopPropagation()
        this.setState({
            showPopover: false
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false)
            if (callback) callback()
        })
    }

    togglePopover(e?: React.MouseEvent, callback?: func) {
        if (e) e.stopPropagation()
        const newValue = !this.state.showPopover
        this.setState({
            showPopover: newValue
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(newValue)
            if (callback) callback()
        })
    }
}
